import axios from 'axios';
// import SessionManager from '../../SessionManager';
// import store from '../../redux/store/index';
// import { showLoader, hideLoader } from '../../redux/actions/loaderAction';
// import ToastService from './toastService';

export const GlobalVariable = Object.freeze({
    APP_VERSION: '1.0.0',
    //BASE_API_URL: `http://192.168.1.102:9000/`,
    // BASE_API_URL: `http://localhost:8000/v1/`,
    BASE_API_URL: `https://salat.ohadtech.com/v1/`,
});

class AjaxService {

    generateUrl(url) {
        return GlobalVariable.BASE_API_URL + url;
    }

    get(url, data) {
        return this.executeRequest(url, data, 'GET');
    }

    post(url, data) {
        return this.executeRequest(url, data, 'POST');
    }

    put(url, data) {
        return this.executeRequest(url, data, 'PUT');
    }

    delete(url) {
        return this.executeRequest(url, null, 'DELETE');
    }

    async executeRequest(url, data, type) {
        //store.dispatch(showLoader());

        let headers = {
            'Accept': 'application/json',
        };

        if (localStorage != undefined) {
            const state = localStorage.getItem("state");
            let storage = JSON.parse(state);

            if (storage !== null && storage.auth !== null && storage.auth.token !== null) {
                headers = {
                    Accept: "application/json",
                    Authorization: `Bearer ${storage.auth.token}`,
                }
            }
        }
        // if (process.browser) {
        // }

        const uri = this.generateUrl('api/web/' + url);

        let options = {
            method: type,
            url: uri,
            headers: headers,
            data: null,
        }

        if (type === 'GET') {
            options.params = data;
        } else if (type === 'POST' || type === 'PUT') {
            options.data = data;
        } else {
            delete options.data;
        }

        return axios(options).then(response => {
            //store.dispatch(hideLoader());
            return response;
        }).catch(function (error) {
            /*
            store.dispatch(hideLoader());
            
            if (uri.includes("ogin") || uri.includes("egister")) {
                ToastService.show('Invalid phone or password');
            } else {
                ToastService.show('Network error. Check your internet connection.');
            }
            */
        });
    }

    async getAccessToken(username, password) {

        let data = {
            client_id: '2',
            client_secret: 'TUNfVlqH1emu37KkZGpgpMSQAjraxuTwlTSstWau',
            username: username,
            password: password,
            grant_type: 'password'
        };

        const uri = this.generateUrl('oauth/token');

        let options = {
            method: 'POST',
            url: uri,
            data: data,
        }

        return axios(options).then(response => {
            //store.dispatch(hideLoader());
            return response;
        }).catch(function (error) {
            //store.dispatch(hideLoader());
            //ToastService.show('Network error. Check your internet connection.');
        });
    }
}

const ajaxService = new AjaxService();

export default ajaxService;